const calculateVat = (value) => ((value / 100) * 20);
// Used for services that haven't been saved calculate VAT on client
const initialChargeWithVatIfApplicable = (service) => (service.isVatRequired
    ? Number(service.initialCharge) + calculateVat(Number(service.initialCharge))
    : Number(service.initialCharge));

export { calculateVat, initialChargeWithVatIfApplicable };
